export default {
  chartType: "onedheatmap",
  showTitle: true,
  showControls: true,
  showQuery: true,
  showColor: true,
  showSortZ: true,
  showSortX: true,
  showSortY: false,
  showNormalize: false,
  showRecency: true,
  showSize: true,
  showMetric: false,
  showMetricX: false,
  showMetricY: false,
  showTypeCats: false
};
